export default "__VITE_ASSET__33dfeb56__"